
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: 'Instantly verify bank accounts to power payments, compliance, and billing in one unified platform with Frame'
};
export const partnerProps = {
  partner: 'Frame',
  clientLibrary: 'frame',
  subtitle: metadata.description,
  registrationUrl: 'https://app.framepayments.com/register',
  apiUrl: 'https://docs.framepayments.com/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and `}<a parentName="p" {...{
        "href": "https://www.framepayments.com/"
      }}>{`Frame`}</a>{` have partnered to give businesses a secure, streamlined foundation for high-compliance payment operations. Where Plaid connects your customers to their bank accounts, Frame handles everything that happens next: identity verification, KYC, fraud monitoring, money movement, billing, payouts, and dispute management, in a single integrated stack.`}</p>
    <p>{`High-compliance merchants like gaming platforms, marketplaces, travel companies, and crypto exchanges use Frame to consolidate what would otherwise be multiple separate vendors into one API, one contract, and one compliance posture. Plaid's bank linking layer slots directly into Frame's identity and money movement products, giving your customers a fast, trusted onboarding experience while Frame manages the regulatory and operational complexity beneath the surface.`}</p>
    <p>{`The Frame API integrates once and scales with you. Start with essentials like account verification, KYC, and ACH money movement, then expand into the full frameOS suite as your compliance and payment needs grow.`}</p>
    <p>{`To get started sign up for `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/keys"
      }}>{`Plaid API keys`}</a>{`.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthIdentityInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
